<template>

  <div
    :class="{'box-loading': loading}">
    <div class="form-group">
      <SelectAvalibleScoreform
        v-model="value.scoreform_id"
        :placeholder="$t('Select a score form')"
        :jobId="selectedJob._id"
        interviewType="voice-interview" />
    </div>

    <div
      v-if="value.scoreform_id"
      class="form-group">
      <div class="row">
        <label class="col-sm-3">{{ $t('Send when') }}:</label>
        <div class="col-sm-9">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type1"
              value="immediately"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type1">
              {{ $t('Immediately') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type2"
              value="schedule"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type2">
              {{ $t('Schedule') }}
            </label>
          </div>
          <ValidateMessage :error="validateErrors.send_type" />

          <div
            class="mt-3"
            v-if="value.send_type === 'schedule'">
            <DelayForm
              v-model="value.send_at" />
            <ValidateMessage :error="validateErrors.send_at" />
          </div>

        </div>
      </div>
    </div>

    <div class="form-group">
      <label>Link expira em (Dias):</label>
      <input
        type="number"
        class="form-control"
        v-model="value.expires_days"
        style="max-width: 70px">
    </div>

    <button
      class="btn btn-primary"
      type="button"
      :disabled="!value.scoreform_id"
      @click="createIntervoiceInvite()">{{ $t('Send') }}</button>
  </div>

</template>

<script>
import SelectAvalibleScoreform from '@/components/Fields/SelectAvalibleScoreform.vue'
import DelayForm from '@/components/Parts/DelayForm'

export default {
  name: 'CandidateIntervoiceInvite',
  components: {
    SelectAvalibleScoreform,
    DelayForm
  },
  props: {},
  data () {
    return {
      loading: false,
      value: {
        scoreform_id: null,
        send_type: 'immediately',
        send_at: null,
        expires_days: 7
      },
      validateErrors: {}
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    alertNoCredits () {
      this.$store
      .dispatch('setAlertModal', {
        type: 'ok',
        title: 'Sem créditos para envio de convite para entrevista por voz.',
        message: 'Contate o administrador.'
      })
    },
    /*
    createIntervoiceInvite
    */
    createIntervoiceInvite (data) {
      this.loading = true

      return this.$store
      .dispatch('createIntervoiceInvite', {
        candidate_id: this.candidate._id,
        job_id: this.selectedJob._id,
        ...this.value
      })
      .then((response) => {
        this.$store.dispatch('refreshSelectIntervoiceInvites')
        this.loading = false
        this.validateErrors = {}
        this.value = {
          scoreform_id: null,
          send_type: 'immediately',
          send_at: null,
          expires_days: 7
        }
      })
      .catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        if (err.response.data.name === 'Forbidden') {
          this.alertNoCredits()
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Intervoice/CandidateIntervoiceInvite.vue